import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/examplesLook.png'


const _withScopeId = n => (_pushScopeId("data-v-47f9e41b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tips"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "secondaryTxt grayTxt" }, "(含物业费)/月", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "secondaryTxt grayTxt" }, "(含物业费)/月", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "secondaryTxt grayTxt" }, "(应与房产证一致)", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新址预计装修费用")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grayTxt" }, "（如有需与预算表一致）", -1))
const _hoisted_7 = { class: "examplesLookContent" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "examplesLookContent-title" }, "示例内容：", -1))
const _hoisted_9 = { class: "examplesLookContent-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "examplesLookBox" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode("查看示例")
], -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("换租理由")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grayTxt" }, "（原则上分公司每年最多换租一次，一般两年一次）", -1))
const _hoisted_13 = { class: "examplesLookContent" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "examplesLookContent-title" }, "示例内容：", -1))
const _hoisted_15 = { class: "examplesLookContent-content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "examplesLookBox" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode("查看示例")
], -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("换租的损失 ")
const _hoisted_18 = { class: "examplesLookContent" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "examplesLookContent-title" }, "示例内容：", -1))
const _hoisted_20 = { class: "examplesLookContent-content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "examplesLookBox" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode("查看示例")
], -1))

import { message } from "ant-design-vue";
import { reactive,ref,onMounted,withDefaults} from "vue";
import { CaretDownOutlined} from "@ant-design/icons-vue";
import { towDecimal, isEmpty,minCompare,maxCompare} from "@/utils/type";
import { 
  addressApplyApi,//地址提交
  addressDetailApi,//地址详情
 } from "@/api/businessChange";
import Image from "@/components/Image.vue"
import {
  GetCity,
} from "@/api/api";
import change from "@/composables/change"

export default /*#__PURE__*/_defineComponent({
  props: {
    BranchCompanyFlowId: { default: 0 },
    reEdit: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { BranchCompanyFlowId: number, reEdit:boolean }



const checkNum2= (val)=> { //输入数字且只能输入二位小数
    let val1 = val.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符 
    val1 = val1.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的   
    val1 = val1.replace(".","$#$").replace(/\./g,"").replace("$#$",".");  
    val1 = val1.replace(/^(!-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数   
    if(val1.indexOf(".")< 0 && val1 !=""){ //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额  
      val1 = parseFloat(val1);  
    }
    return val1
}
const setInput =(key:string)=>{//小数点两位处理
  FormData.PageData[key] = checkNum2(FormData.PageData[key])
}
//小数点两位的校验
const validateNum2 = async (_rule:any, value:string,text:string,min:string) => {
  if (isEmpty(value)) {
    return Promise.reject(`请输入${text}`);
  } else  if (!towDecimal(value)) {
    return Promise.reject("最多输入2位小数");
  } else if (!minCompare(value, min) || !maxCompare(value, '999999')){
    return Promise.reject(`请输入${min}-999999之间的数`);
  } else{
    return Promise.resolve()
  }
}
//正整数校验
const validateNum = async (_rule:any, value:string,text:string) => {
  if (isEmpty(value)) {
    return Promise.reject(`请输入${text}`);
  } else  if (!minCompare(value, '1') || !maxCompare(value, '999999')){
    return Promise.reject("请输入1-999999之间的整数");
  } else{
    return Promise.resolve()
  }
}
//字段定义
const data = reactive({
  gsxzSelect:[],
  tips1:"不需装修费，新址为精装修房源，高品质精装带全套所有办公家居，与开发商直接签约，能提供正规发票，只需增加企业文化软装部分，带电脑就可以办公。",
  tips2:" 1、现办公场地合同正常到期，现址房屋因产权抵押目钱银行已申请拍卖；\n2、地段升级为市中心，一环核心区域，交通，配套都升级很多，利于招聘。 \n3、新址为5A写字楼，办公环境好、档次高，面积增加、便于客户洽谈，面试。以及客户的开发。 \n4、并且是房源为精装修节约装修费用拎包入住，综合性价比高很多； \n5、港资开发商，交付标准高，并且风水方面很有讲究，利于发展。 \n6、直接跟开发商签约，相对现在更有保障，并且包含所有的租金税费，相比现在的不含税的成本，总体差距其实很小。 \n计划安排： \n1、已选定新的办公房源， \n2、经多维度论证，新场地符合公司往后1-2年的发展对场地需求； ",
  tips3:'1、无已支付房租的损失；\n2、新址软装、电话移机、网络移动、人工等费用；\n合计预计在5000元以内。',
  ynSelect:[
    {
      value: 1,
      label: '是',
    },{
      value: 0,
      label: '否',
    },
  ],
  applySelect:[
    {
      value: 1,
      label: '换租申请',
    },{
      value: 2,
      label: '续租申请',
    },{
      value: 3,
      label: '主体变更申请',
    },
  ]
})





const allCity = ref<
  {
    value: string;
    label: string;
  }[]
>([]);

const FormData= reactive({
  PageFiles:[],
  PageData:{
    ReasonType:undefined,
    IsEnter:undefined,
    OfficeSpaceOld:undefined,
    OfficeSpaceNew:undefined,
    ProvinceCodeOld:"",
    ProvinceNameOld:'',
    RentSalaryOld:'',
    RentSalaryNew:'',
    RentStartTimeOld:'',
    RentEndTimeOld:'',
    RentStartTimeNew:'',
    RentEndTimeNew:'',
    WorkplaceSalaryOld:'',
    WorkplaceSalaryNew:'',
    CapacityOld:'',
    CapacityNew:'',
    RentHouseName:'',
    RentDeadline:'',
    PayTypeDesc:'',
    FirstPayment:'',
    IsBigPropertyOrg:undefined,
    IsProvideInvoice:undefined,
    DecorationCostDesc:'',
    ChangeRentReason:'',
    RentTimeNew:[],
    RentTimeOld:[],
  }
})
//封装方法字段
const FormRef = ref()
const common = reactive({
  ApplyApi:addressApplyApi,
  DetailApi:addressDetailApi,
  FormData:FormData,
  nodeIdx:1,
  FormRef:FormRef,
  props:reactive(props),
})

//上传附件
const handleUpload = (file: File, index?: number) => {
  if (!file) {
    FormData.PageFiles.splice(index, 1);
  } else {
    let obj ={
      ...file,
      FileUrl: file.Url,
      url: file.url,
      name: file.name,
    }
    FormData.PageFiles.push(obj)
  }
};
// //上传-删除后台文件
// const rightChaClick = (index: number) => {
//   FormData.PageFiles.splice(index, 1);
// }
// 获取城市数据
const getCityData = async (city: string) => {
  const { Data, Success, Message } = await GetCity({
    KeyWord: city,
  });
  if (Success) {
    allCity.value = Data.Citys;
  } else {
    message.warning(Message);
  }
};
// 选定城市
const citysChange = (val, option,type) => {
  if(val.length){
    FormData.PageData[`ProvinceCode${type}`] = val[0]
    FormData.PageData[`ProvinceName${type}`] = option[0].Text
    FormData.PageData[`CityCode${type}`] = val[val.length - 2]
    FormData.PageData[`CityName${type}`] = option[option.length - 2].Text
    FormData.PageData[`DistrictCode${type}`] = val[val.length - 1]
    FormData.PageData[`DistrictName${type}`] = option[option.length - 1].Text
  }
};
//选定时间
const timeChange =(date, dateString,type)=>{
  FormData.PageData[`RentStartTime${type}`]  = date[0]
  FormData.PageData[`RentEndTime${type}`]  = date[1]
}

const {
  form,
} = change(common)

onMounted(() => {
  getCityData("");
});

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    class: "addressForm",
    ref_key: "FormRef",
    ref: FormRef,
    model: _unref(FormData),
    labelAlign: "left",
    "label-col": { style: { width: '130px' } },
    colon: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'ReasonType'],
        label: "申请原因",
        rules: [{ required: true, message: '请选择申请原因' }]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _unref(FormData).PageData.ReasonType,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(FormData).PageData.ReasonType) = $event)),
            placeholder: "请选择",
            options: _unref(data).applySelect
          }, {
            suffixIcon: _withCtx(() => [
              _createVNode(_unref(CaretDownOutlined), { class: "ant-select-suffix" })
            ]),
            _: 1
          }, 8, ["value", "options"]),
          (_unref(FormData).PageData.ReasonType == 3)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "注:此申请仅针对租房地址未变更，物业公司/房东等主体变更的情况"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'IsEnter'],
        label: "是否入驻产业园",
        rules: [{ required: true, message: '请选择是否入驻产业园' }]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _unref(FormData).PageData.IsEnter,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(FormData).PageData.IsEnter) = $event)),
            placeholder: "请选择",
            options: _unref(data).ynSelect
          }, {
            suffixIcon: _withCtx(() => [
              _createVNode(_unref(CaretDownOutlined), { class: "ant-select-suffix" })
            ]),
            _: 1
          }, 8, ["value", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'AddressBefore'],
        label: "原办公地址",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            placeholder: "请填写",
            value: _unref(FormData).PageData.AddressBefore,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(FormData).PageData.AddressBefore) = $event)),
            maxlength: "200",
            "auto-size": ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'AddressAfter'],
        label: "新办公地址",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            placeholder: "请填写",
            value: _unref(FormData).PageData.AddressAfter,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(FormData).PageData.AddressAfter) = $event)),
            maxlength: "200",
            "auto-size": ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'BusinessRegisteredAddress'],
        label: "工商注册地址",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            placeholder: "请填写",
            value: _unref(FormData).PageData.BusinessRegisteredAddress,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(FormData).PageData.BusinessRegisteredAddress) = $event)),
            maxlength: "200",
            "auto-size": ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'OfficeSpaceOld'],
        label: "原办公面积",
        rules: [{ required: true,validator: (_rule, value)=>validateNum2(_rule, value,'原办公面积','1')}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            onInput: _cache[5] || (_cache[5] = ($event: any) => (setInput('OfficeSpaceOld'))),
            placeholder: "请填写",
            suffix: "平方米",
            value: _unref(FormData).PageData.OfficeSpaceOld,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(FormData).PageData.OfficeSpaceOld) = $event)),
            maxlength: "9"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'OfficeSpaceNew'],
        label: "新办公面积",
        rules: [{ required: true,validator: (_rule, value)=>validateNum2(_rule, value,'新办公面积','1')}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            onInput: _cache[7] || (_cache[7] = ($event: any) => (setInput('OfficeSpaceNew'))),
            placeholder: "请填写",
            suffix: "平方米",
            value: _unref(FormData).PageData.OfficeSpaceNew,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(FormData).PageData.OfficeSpaceNew) = $event)),
            maxlength: "9"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'cityOld'],
        label: "原区域",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_cascader, {
            class: "citys",
            value: _unref(FormData).PageData.cityOld,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(FormData).PageData.cityOld) = $event)),
            options: allCity.value,
            placeholder: "选定城市",
            "expand-trigger": "hover",
            "show-arrow": false,
            pacement: "bottomLeft",
            props: { emitPath: false, value: 'Id', label: 'Text' },
            fieldNames: {
          label: 'Text',
          value: 'Id',
          children: 'Childs',
        },
            onChange: _cache[10] || (_cache[10] = (val, option)=>citysChange(val, option,'Old'))
          }, null, 8, ["value", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'cityNew'],
        label: "新区域",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_cascader, {
            class: "citys",
            value: _unref(FormData).PageData.cityNew,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(FormData).PageData.cityNew) = $event)),
            options: allCity.value,
            placeholder: "选定城市",
            "expand-trigger": "hover",
            "show-arrow": false,
            pacement: "bottomLeft",
            props: { emitPath: false, value: 'Id', label: 'Text' },
            fieldNames: {
          label: 'Text',
          value: 'Id',
          children: 'Childs',
        },
            onChange: _cache[12] || (_cache[12] = (val, option)=>citysChange(val, option,'New'))
          }, null, 8, ["value", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'RentSalaryOld'],
        label: "原租金",
        rules: [{ required: true,validator: (_rule, value)=>validateNum2(_rule, value,'原租金','0')}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            onInput: _cache[13] || (_cache[13] = ($event: any) => (setInput('RentSalaryOld'))),
            placeholder: "请填写",
            suffix: "元",
            value: _unref(FormData).PageData.RentSalaryOld,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_unref(FormData).PageData.RentSalaryOld) = $event)),
            maxlength: "9"
          }, null, 8, ["value"]),
          _hoisted_2
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'RentSalaryNew'],
        label: "新租金",
        rules: [{ required: true,validator: (_rule, value)=>validateNum2(_rule, value,'新租金','0')}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            onInput: _cache[15] || (_cache[15] = ($event: any) => (setInput('RentSalaryNew'))),
            placeholder: "请填写",
            suffix: "元",
            value: _unref(FormData).PageData.RentSalaryNew,
            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_unref(FormData).PageData.RentSalaryNew) = $event)),
            maxlength: "9"
          }, null, 8, ["value"]),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'RentTimeOld'],
        label: "原租赁起止时间",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_range_picker, {
            valueFormat: "YYYY-MM-DD",
            value: _unref(FormData).PageData.RentTimeOld,
            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(FormData).PageData.RentTimeOld) = $event)),
            onChange: _cache[18] || (_cache[18] = (date, dateString) =>timeChange(date, dateString,'Old'))
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'RentTimeNew'],
        label: "新租赁起止时间",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_range_picker, {
            valueFormat: "YYYY-MM-DD",
            value: _unref(FormData).PageData.RentTimeNew,
            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_unref(FormData).PageData.RentTimeNew) = $event)),
            onChange: _cache[20] || (_cache[20] = (date, dateString) =>timeChange(date, dateString,'New'))
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'WorkplaceSalaryOld'],
        label: "原址职场押金",
        rules: [{ required: true,validator: (_rule, value)=>validateNum2(_rule, value,'原址职场押金','0')}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            onInput: _cache[21] || (_cache[21] = ($event: any) => (setInput('WorkplaceSalaryOld'))),
            placeholder: "请填写",
            suffix: "元",
            value: _unref(FormData).PageData.WorkplaceSalaryOld,
            "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_unref(FormData).PageData.WorkplaceSalaryOld) = $event)),
            maxlength: "9"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'WorkplaceSalaryNew'],
        label: "新址职场押金",
        rules: [{ required: true,validator: (_rule, value)=>validateNum2(_rule, value,'新址职场押金','0')}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            onInput: _cache[23] || (_cache[23] = ($event: any) => (setInput('WorkplaceSalaryNew'))),
            placeholder: "请填写",
            suffix: "元",
            value: _unref(FormData).PageData.WorkplaceSalaryNew,
            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_unref(FormData).PageData.WorkplaceSalaryNew) = $event)),
            maxlength: "9"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'CapacityOld'],
        label: "原址可容纳人数",
        rules: [{ required: true,validator: (_rule, value)=>validateNum(_rule, value,'原址可容纳人数')}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            oninput: "value=value.replace(/^\\.+|[^\\d]+/g,'')",
            placeholder: "请填写",
            suffix: "人",
            value: _unref(FormData).PageData.CapacityOld,
            "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_unref(FormData).PageData.CapacityOld) = $event)),
            maxlength: "6"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'CapacityNew'],
        label: "新址可容纳人数",
        rules: [{ required: true,validator: (_rule, value)=>validateNum(_rule, value,'新址可容纳人数')}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            oninput: "value=value.replace(/^\\.+|[^\\d]+/g,'')",
            placeholder: "请填写",
            suffix: "人",
            value: _unref(FormData).PageData.CapacityNew,
            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_unref(FormData).PageData.CapacityNew) = $event)),
            maxlength: "6"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'RentHouseName'],
        label: "出租房名称",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            placeholder: "请填写",
            value: _unref(FormData).PageData.RentHouseName,
            "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_unref(FormData).PageData.RentHouseName) = $event)),
            maxlength: "50"
          }, null, 8, ["value"]),
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'FirstPayment'],
        label: "首期需支付现金流",
        rules: [{ required: true,validator: (_rule, value)=>validateNum2(_rule, value,'首期需支付现金流','0')}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            onInput: _cache[28] || (_cache[28] = ($event: any) => (setInput('FirstPayment'))),
            placeholder: "请填写",
            suffix: "万元",
            value: _unref(FormData).PageData.FirstPayment,
            "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_unref(FormData).PageData.FirstPayment) = $event)),
            maxlength: "9"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'IsBigPropertyOrg'],
        label: "出租房是否为大产权单位",
        class: "FormLong",
        rules: [{ required: true, message: '请选择出租房是否为大产权单位' }]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _unref(FormData).PageData.IsBigPropertyOrg,
            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_unref(FormData).PageData.IsBigPropertyOrg) = $event)),
            placeholder: "请选择",
            options: _unref(data).ynSelect
          }, {
            suffixIcon: _withCtx(() => [
              _createVNode(_unref(CaretDownOutlined), { class: "ant-select-suffix" })
            ]),
            _: 1
          }, 8, ["value", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'IsProvideInvoice'],
        label: "出租房是否提供正规发票",
        class: "FormLong",
        rules: [{ required: true, message: '请选择出租房是否提供正规发票' }]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _unref(FormData).PageData.IsProvideInvoice,
            "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_unref(FormData).PageData.IsProvideInvoice) = $event)),
            placeholder: "请选择",
            options: _unref(data).ynSelect
          }, {
            suffixIcon: _withCtx(() => [
              _createVNode(_unref(CaretDownOutlined), { class: "ant-select-suffix" })
            ]),
            _: 1
          }, 8, ["value", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'DecorationCostDesc'],
        class: "textareaLine",
        rules: [{ required: true, message: '请输入新址预计装修费用' }]
      }, {
        label: _withCtx(() => [
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_a_popover, {
            placement: "rightTop",
            overlayClassName: "examplesLook-wrap",
            "arrow-point-at-center": ""
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(data).tips1), 1)
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            placeholder: "请填写",
            value: _unref(FormData).PageData.DecorationCostDesc,
            "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_unref(FormData).PageData.DecorationCostDesc) = $event)),
            maxlength: "200",
            "auto-size": { minRows: 3, maxRows: 7 }
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'ChangeRentReason'],
        class: "textareaLine",
        rules: [{ required: true, message: '请输入换租理由' }]
      }, {
        label: _withCtx(() => [
          _hoisted_11,
          _hoisted_12,
          _createVNode(_component_a_popover, {
            placement: "rightTop",
            overlayClassName: "examplesLook-wrap",
            "arrow-point-at-center": ""
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(data).tips2), 1)
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            placeholder: "请填写",
            value: _unref(FormData).PageData.ChangeRentReason,
            "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_unref(FormData).PageData.ChangeRentReason) = $event)),
            maxlength: "200",
            "auto-size": { minRows: 3, maxRows: 7 }
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: "PageFiles",
        label: "上传房屋照片",
        class: "textareaLine uploadBox",
        rules: [{ required: true, message: '请上传房屋照片' }]
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FormData).PageFiles, (item, index) => {
            return (_openBlock(), _createBlock(Image, {
              key: item,
              value: item.FileUrl,
              disable: true,
              "disable-close": false,
              onUpload: (file) => handleUpload(file, index),
              "file-type": '811'
            }, null, 8, ["value", "onUpload"]))
          }), 128)),
          (_unref(FormData).PageFiles.length < 10)
            ? (_openBlock(), _createBlock(Image, {
                key: 0,
                onUpload: handleUpload,
                "file-type": '811',
                disable: false,
                "disable-close": true
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        name: ['PageData', 'ChangeRentLose'],
        required: "",
        class: "textareaLine",
        rules: [{ required: true, message: '请输入换租的损失' }]
      }, {
        label: _withCtx(() => [
          _hoisted_17,
          _createVNode(_component_a_popover, {
            placement: "rightTop",
            overlayClassName: "examplesLook-wrap",
            "arrow-point-at-center": ""
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(data).tips3), 1)
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            placeholder: "请填写",
            value: _unref(FormData).PageData.ChangeRentLose,
            "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_unref(FormData).PageData.ChangeRentLose) = $event)),
            maxlength: "200",
            "auto-size": { minRows: 3, maxRows: 7 }
          }, null, 8, ["value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})